__webpack_require__.p = "/gold/";